'use client';

/**
 * useAuth + notifyUserContextChanged — re-exports from auth-context.tsx.
 *
 * SPEC-167 (Sprint 83, 2026-09-10): the original per-instance useAuth
 * implementation was refactored into a Context Provider pattern to fix
 * P-282 (190+ requests `/api/auth/me` per session).
 *
 * This file re-exports the new API for backward compatibility:
 * - 32 call sites across the codebase import `useAuth` from `@/lib/use-auth`.
 * - Keeping the import path stable avoids touching all 32 files.
 *
 * The actual implementation now lives in `auth-context.tsx` which exports
 * `AuthProvider` (mount once at root layout) + `useAuth` (reads from context)
 * + `notifyUserContextChanged` (dispatches `profileia:user-changed` event).
 *
 * Spec ref: SPEC-167 (P-282), CONTRATO-IA-PROGRAMADORA §2.1 (Spec-First).
 * §6 Anti-Invención: 0 business logic — pure infrastructure refactor.
 */

export { useAuth, notifyUserContextChanged } from './auth-context';
